import { render, staticRenderFns } from "./AccountSetup.vue?vue&type=template&id=74625dc4&"
import script from "./AccountSetup.vue?vue&type=script&lang=js&"
export * from "./AccountSetup.vue?vue&type=script&lang=js&"
import style0 from "../../styles/vue-multiselect.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports